import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const Section = ({ title, children, isLast, id, innerRef }) => {
    const classes = classNames({
        'brief-section': true,
        'brief-section--last': isLast,
    });
    return (
        <div className={classes} id={'section-' + id} ref={innerRef}>
            {title && <h2 className="brief-section__title">{title}</h2>}
            <div className="brief-section__elements">{children}</div>
        </div>
    );
};
Section.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    isLast: PropTypes.bool,
    innerRef: PropTypes.func,
};
Section.defaultProps = {
    title: null,
    isLast: false,
};
export default Section;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/section.jsx